import Mock from 'mockjs'
import { param2Obj } from 'src/utils'
import {course_name, agent_name, publish_name, class_name, college, campus, grades, edition} from './datas';
import {random} from 'lodash';

const List = []
const count = 100

for (let j = 0; j < count; j++) {
  const children = [];
  for (let k = 0; k < random(2, 8); k++) {
    const childrens = [];
    for(let m = 0; m < random(1,2); m++){
      childrens.push(Mock.mock({
        'book_name': '@ctitle',
        'edition|1': edition,
        'publisher|1': publish_name,
        'author': '@cname',
        'reserve_number': '@integer(40,50)',
        'receive_number': function(){
          return this.reserve_number - Math.floor(Math.random() * 4)
        },
        price: '@integer(70,99)',
        discount: '@integer(70,99)'
      }))
    }
    children.push(Mock.mock({
      'course_name|1': course_name,
      teacher_name: '@cname',
      children: childrens
    }))
  }
  List.push(Mock.mock({
    id: '@increment',
    'class_name|1': class_name,
    'college_name|1': college,
    'campus_name|1':campus,
    children
  }))
}
const recordList = []
const counts = 5

for (let j = 0; j < counts; j++) {
  const children = [];
  for (let k = 0; k < random(2, 8); k++) {
    const childrens = [];
    for(let m = 0; m < random(1,2); m++){
      childrens.push(Mock.mock({
        'book_name': '@ctitle',
        'edition|1': edition,
        'publisher|1': publish_name,
        'author': '@cname',
        'reserve_number': '@integer(40,50)',
        'receive_number': function(){
          return this.reserve_number - Math.floor(Math.random() * 4)
        },
        price: '@float(50,100,0,2)',
        discount: '@integer(70,99)',
        'received_students|30-40': ['@cname'],
        'unreceived_students|1-8': ['@cname'],
      }))
    }
    children.push(Mock.mock({
      'course_name|1': course_name,
      teacher_name: '@cname',
      children: childrens
    }))
  }
  recordList.push(Mock.mock({
    id: '@increment',
    name: '@cname',
    student_number: '@string("number", 10)',
    telphone_number: '@string("number", 11)',
    date: '@date("yyyy-MM-dd")',
    children
  }))
}



let teacherList = [];
for (let j = 0; j < count; j++) {
  const children = [];
  for (let k = 0; k < random(1, 4); k++) {
    const childrens = [];
    for(let m = 0; m < random(1,2); m++){
      childrens.push(Mock.mock({
        'book_name': '@ctitle',
        'edition|1': edition,
        'publisher|1': publish_name,
        'author': '@cname',
        price: '@float(50,100,0,2)',
        teacher_name: '@cname',
        discount: '@integer(70,99)',
        assgin_status: '@boolean'
      }))
    }
    children.push(Mock.mock({
      'course_name|1': course_name,
      children: childrens
    }))
  }
  teacherList.push(Mock.mock({
    id: '@increment',
    teacher_name: '@cname',
    teacher_number: '@string("number", 10)',
    'class_name|1': class_name,
    'college_name|1': college,
    'campus_name|1':campus,
    children
  }))
}


const assginList = [];
for (let i = 0; i < count; i++) {
  const children = [];
  for (let k = 0; k < random(2, 8); k++) {
    let childrens = [];
    for(let m = 0; m < random(1,2); m++){
      childrens.push(Mock.mock({
        'book_name': '@ctitle',
        'edition|1': edition,
        'publisher|1': publish_name,
        'author': '@cname',
        'receive_number': '@integer(40,50)',
        price: '@float(50,100,0,2)',
        teacher_name: '@cname',
        discount: '@integer(70,99)'
      }))
    }
    children.push(Mock.mock({
      'course_name|1': course_name,
      children: childrens
    }))
  }
  assginList.push(Mock.mock({
    id: '@increment',
    name: '@cname',
    student_number: '@string("number", 10)',
    telphone_number: '@string("number", 11)',
    'class_name|1': class_name,
    'grade_name|1': grades,
    'college_name|1': college,
    'campus_name|1':campus,
    number: '@integer(400,500)',
    total_price: '@float(8000,9000,2,2)',
    assgin_date: '@date("yyyy-MM-dd")',
    children
  }))
}

const assginList2 = [];
for (let i = 0; i < count; i++) {
  const children = [];
  for (let k = 0; k < random(1, 4); k++) {
    const childrens = [];
    for(let m = 0; m < random(1,2); m++){
      childrens.push(Mock.mock({
        'book_name': '@ctitle',
        'edition|1': edition,
        'publisher|1': publish_name,
        'author': '@cname',
        'receive_number': '@integer(40,50)',
        price: '@float(50,100,0,2)',
        teacher_name: '@cname',
        discount: '@integer(70,99)',
        assgin_status: '@boolean'
      }))
    }
    children.push(Mock.mock({
      'course_name|1': course_name,
      children: childrens
    }))
  }
  assginList2.push(Mock.mock({
    id: '@increment',
    name: '@cname',
    teahcer_number: '@string("number", 10)',
    telphone_number: '@string("number", 11)',
    'college_name|1': college,
    'campus_name|1':campus,
    'class_name|1': class_name,
    number: '@integer(400,500)',
    total_price: '@float(8000,9000,2,2)',
    assgin_date: '@date("yyyy-MM-dd")',
    children
  }))
}

const assginList1 = [];
for (let i = 0; i < count; i++) {
  const children = [];
  for (let k = 0; k < random(2, 8); k++) {
    children.push(Mock.mock({
      'teacher_name|2': ['@cname','@cname'],
      'book_name': '@ctitle',
      'edition|1': edition,
      'publisher|1': publish_name,
      'author': '@cname',
      price: '@float(50,100,0,2)',
      discount: '@integer(70,99)'
    }))
  }
  assginList1.push(Mock.mock({
    id: '@increment',
    name: '@cname',
    teahcer_number: '@string("number", 10)',
    telphone_number: '@string("number", 11)',
    'college_name|1': college,
    'campus_name|1':campus,
    number: '@integer(400,500)',
    total_price: '@float(8000,9000,2,2)',
    assgin_date: '@date("yyyy-MM-dd")',
    children
  }))
}

export default {
  getList: config => {
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = List.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },

  getList1: config => {
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = teacherList.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },



  getAssginList: config =>{
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = assginList.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },

  getAssginList1: config =>{
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = assginList1.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },

  getAssginList2: config =>{
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = assginList2.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },

  getRecordList: config =>{
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = recordList.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/send.js